import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { MENU_ITEM_KEY_LPS, REPORT_CONFIG_NAME_LPS } from '../globals.ts'
import { resolveReportIdForMenuItem } from '../utils/reportingGridColumns.ts'

/** `reporting_config.id` for the LPs grid column layout (from global configs). */
export function useLpsReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () => resolveReportIdForMenuItem(reportingConfigs, menuItems, MENU_ITEM_KEY_LPS, REPORT_CONFIG_NAME_LPS),
    [menuItems, reportingConfigs]
  )
}
